'use strict';

var url = require('../utils/commonjs/uri').URL;

/**
 * Returns the value of the utm_medium query param.
 * @returns {string}
 */
function getReferringMedium(queryKey) {
    queryKey = queryKey || url.queryKey;
    return (queryKey.utm_medium ? queryKey.utm_medium.toLowerCase() : '');
}

/**
 * Returns true if the user came to the site from clicking a PLA ad.
 * @returns {boolean}
 */
function isPlaReferrer() {
    var queryKey = url.queryKey;
    return getReferringMedium() === 'pla' || (typeof queryKey.product !== 'undefined' && typeof queryKey.gclid !== 'undefined');
}

/**
 * Returns true if we the user came to the site from clicking a link in an email.
 * @returns {boolean}
 */
function isEmailReferrer(queryKey) {
    return getReferringMedium(queryKey) === 'email';
}

/**
 * Returns true if we the user came to the site from AMP page.
 * @returns {boolean}
 */
function isAmpReferrer() {
    var referrer = document.referrer;
    return referrer.match(/\/amp\//g) !== null;
};

module.exports = {
    getReferrer: function () {
        return (document.referrer ? document.referrer.toLowerCase() : '');
    },
    /**
     * Returns true if the user came to the site from google, yahoo, or bing
     */
    isSearchEngine: function () {
        return this.getReferrer().match(/google|yahoo|bing/gi) !== null;
    },
    /**
     * Returns true if the user came to the site from 1stdibs (not first page load)
     */
    is1stdibsReferrer: function () {
        return this.getReferrer().match(/1stdibs/gi) !== null;
    },

    isPinterestReferrer: function () {
        return this.getReferrer().match(/\/\/www.pinterest.com\//) !== null;
    },

    getReferringMedium: getReferringMedium,
    isPlaReferrer: isPlaReferrer,
    isEmailReferrer: isEmailReferrer,
    isAmpReferrer: isAmpReferrer
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/tracking/referrerHelpers.js
// module id = 1196
// module chunks = 63